import React from 'react';
import { CheckCircle, RefreshCw, Upload } from 'lucide-react';


const BatchActionsBar = ({
  selectedPhotos,
  jobResults,
  providerName,
  onClearSelection,
  onApply,
  isApplying
}) => {
  const selectedCount = selectedPhotos.size;

  if (selectedCount === 0) {
    return null;
  }

  // Check if all selected photos have already been applied
  const allSelectedPhotosApplied = jobResults
    ? Array.from(selectedPhotos).every((photoId) => {
        const photo = jobResults.find((result) => result.photoId === photoId);
        return photo && photo.applied === true;
      })
    : false;

  // Don't show the bar if all selected photos are already applied
  if (allSelectedPhotosApplied) {
    return null;
  }

  const selectedWithExisting = jobResults
    ? Array.from(selectedPhotos).filter((photoId) => {
        const photo = jobResults.find((result) => result.photoId === photoId);
        return photo && (photo.originalTitle || photo.originalDescription);
      }).length
    : 0;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-2">
              <CheckCircle className="w-5 h-5 text-blue-600" />
              <span className="font-semibold text-gray-900">
                {selectedCount} photo{selectedCount !== 1 ? 's' : ''} selected
              </span>
            </div>

            {selectedWithExisting > 0 && (
              <span className="text-xs bg-amber-100 text-amber-800 px-2 py-1 rounded-full">
                {selectedWithExisting} will replace existing content
              </span>
            )}
          </div>

          <div className="flex items-center space-x-3">
            <button
              onClick={onClearSelection}
              className="text-sm text-gray-600 hover:text-gray-800 font-medium"
            >
              Clear Selection
            </button>

            <button
              onClick={onApply}
              disabled={isApplying || selectedCount === 0}
              className="inline-flex items-center px-6 py-3 bg-blue-600 text-white font-bold text-lg rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isApplying ? (
                <>
                  <RefreshCw className="mr-2 h-5 w-5 animate-spin" />
                  Applying...
                </>
              ) : (
                <>
                  <Upload className="mr-2 h-5 w-5" />
                  Apply {selectedCount} to {providerName}
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BatchActionsBar;
